import { Fragment, FunctionComponent, ReactElement } from 'react';
import './form-input-errors.scss';

interface FormInputErrorsProps {
	errors?: string | string[];
}

const FormInputErrors: FunctionComponent<FormInputErrorsProps> = ({ errors }): ReactElement => (
	<Fragment>
		{[...(Array.isArray(errors) ? errors : [errors])]?.map((error, key) => (
			<span className="form-input-error" key={key}>
				{error}
			</span>
		))}
	</Fragment>
);
export default FormInputErrors;
